import React from 'react';
import { Private } from '@ally/private';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { TextBody, Link as MuiLink, ScreenReaderOnly } from '@ally/metronome-ui';
import { StyledTextBody, StyledDL, StyledDT, StyledDD } from './SharedStyles';
import { formattedDate, spreadNumberA11y } from '../utils';
import { SERVER_TIMEZONE } from '../../constants';
dayjs.extend(timezone);
dayjs.extend(utc);
export function getCheckShippedDescription(statuses) {
    const shippedDate = statuses && statuses.find(history => history.status === 'Shipped');
    const estimatedShipDate = shippedDate &&
        dayjs(shippedDate.eventDateTime)
            .tz(SERVER_TIMEZONE)
            .add(14, 'd')
            .format('MMM D');
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledTextBody, { tag: "p", size: "sm", mb: "sm" }, "Your check order was shipped and should arrive within 10 days."),
        React.createElement(TextBody, { tag: "p", size: "sm" },
            "If you don't receive it by ",
            estimatedShipDate,
            ", call us at",
            ' ',
            React.createElement(TextBody, { tag: "span", size: "sm", weight: "bold" },
                React.createElement(MuiLink, { text: "1-877-247-2559", "aria-label": "1, 8 7 7, 2 4 7, 2 5 5 9", allytmln: "1-877-247-2559", href: "tel:1-877-247-2559" })),
            ' ',
            "so we can help.")));
}
export const StatusModalCheckDetails = ({ event }) => {
    const { eventModelData, statuses } = event;
    const inProcessDate = statuses &&
        statuses.find(history => history.status === 'InProcess' || history.status === 'Confirmed');
    const { addressLine1 = '', city = '', stateCode = '', zip = '', } = eventModelData;
    return (React.createElement(StyledDL, null,
        inProcessDate && (React.createElement(React.Fragment, null,
            React.createElement(StyledDT, null, "Ordered On"),
            React.createElement(StyledDD, null, formattedDate(inProcessDate.eventDateTime, 'MMM D, YYYY')))),
        React.createElement(StyledDT, null, "Mailing Address"),
        React.createElement(StyledDD, null,
            React.createElement(Private, null,
                addressLine1,
                " ",
                React.createElement("br", null),
                city,
                ",\u00A0",
                stateCode,
                "\u00A0",
                React.createElement(TextBody, { tag: "span", size: "sm", "aria-hidden": "true" }, zip)),
            React.createElement(ScreenReaderOnly, null, spreadNumberA11y(zip)))));
};
//# sourceMappingURL=StatusModalCheckData.js.map